import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import language from './modules/language';
import navbar from './modules/navbar';
import subordinate from './modules/subordinate';
import * as actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
    actions,
    modules: {
        user,
        language,
        navbar,
        subordinate
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js